import React from 'react';

import './legendItem.scss';

interface IListItemData {
    label: string;
    color: string;
    data: number;
}

const LegendItem: React.FC<{ data: IListItemData }> = ({ data }) => {
    const color = {
        backgroundColor: data.color,
    };

    return (
        <div className='status-summary-body_chart-legend-item'>
            <div className='chart-legend-item_color' style={color}></div>
            <div className='chart-legend-item_label'>{data.label}</div>
            <div className='chart-legend-item_data'>{data.data}</div>
        </div>
    );
};

export default LegendItem;
